import { render, staticRenderFns } from "./roomPriceList.vue?vue&type=template&id=143800a2&scoped=true"
import script from "./roomPriceList.vue?vue&type=script&lang=js"
export * from "./roomPriceList.vue?vue&type=script&lang=js"
import style0 from "./roomPriceList.vue?vue&type=style&index=0&id=143800a2&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143800a2",
  null
  
)

export default component.exports